import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Button from "../../Subcomponents/Button";
import cssClasses from "./EMandate.module.css";
import { Card } from "@mui/material";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import { useNavigate } from "react-router-dom";

// 🔹 Back button style (used in both sections)
const backBtnStyle = {
  height: "48px",
  borderRadius: "12px",
  border: "1px solid #d1d5db",
  backgroundColor: "#ffffff",
  color: "#0f172a",
  boxShadow: "none",
  fontSize: "1.52rem",
};

const SplitOption = ({
  allotment,
  allotmentPaymentId,
  totalMandateAmount,
  bookingId,
}) => {
  const navigate = useNavigate();

  const handleBackToAllotments = () => {
    navigate("/Home/EMandate");
  };

  const handleSplitAmount = () => {
    navigate("/Home/SplitAmount", {
      state: {
        allotment,
        totalMandateAmount,
        bookingId,
        allotmentPaymentId, // ✅ IMPORTANT
      },
    });
  };

  const handleSingleApplicant = () => {
    navigate("/Home/SingleApplicant", {
      state: {
        allotment,
        totalMandateAmount,
        bookingId,
        allotmentPaymentId, // ✅ IMPORTANT
      },
    });
  };

  return (
    <div className={cssClasses.wrapper}>
      <div className={cssClasses.header}>
        <h2>E-Mandate Split Option</h2>
        <p>Choose how to distribute the mandate between the applicants.</p>
      </div>

      <Card className={cssClasses.amountCard} elevation={0}>
        <span>Total Mandate Amount</span>
        <strong>₹{numberWithCommas(totalMandateAmount)}</strong>
      </Card>

      {/* 🔹 REQUIRED INFO BOX */}
      <div className={cssClasses.infoBox}>
        <span className={cssClasses.infoIcon}>
          {" "}
          <PeopleOutlineIcon sx={{ fontSize: 22, color: "#26A98F" }} />
        </span>
        <p>Do you want to split the E-Mandate amount between applicants?</p>
      </div>

      {/* 🔹 ACTION CARDS */}
      <div className={cssClasses.actionRow}>
        <div className={cssClasses.splitBtn} onClick={handleSplitAmount}>
          <PeopleOutlineIcon sx={{ fontSize: 22 }} />
          <span>Yes, Split Amount</span>
        </div>

        <div className={cssClasses.splitBtn} onClick={handleSingleApplicant}>
          <CheckCircleOutlineIcon sx={{ fontSize: 22 }} />
          <span>No, Single Applicant</span>
        </div>
      </div>

      <Button
        btnName="Back to Allotments"
        style={backBtnStyle}
        // clicked={() => setActiveStep(0)}
        clicked={handleBackToAllotments}
      />
    </div>
  );
};

const cardStyle = {
  height: "80px",
  borderRadius: "12px",
  border: "1px solid #d1d5db",
  backgroundColor: "#fff",
};

export default SplitOption;
